var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./scripts/treatment-rule-list.js"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-77591705!../../node_modules/vue-loader/lib/template-loader?raw&engine=pug!./templates/treatment-rule-list.pug"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/TreatmentRuleList.vue
// module id = 1366
// module chunks = 1